<template>
    <div :id="idComponent" class="hs-tooltip inline-block">
        <slot></slot>
        <div role="tooltip" :class=" $slots.description ? styleClass.withSlot : styleClass.default">
            <div v-if="label" :class="[description ? 'rounded-t-lg' : 'rounded-lg', 'px-3 py-2 bg-gray-100 border-b border-gray-400  dark:border-gray-600 dark:bg-gray-700']">
                <h3 class="font-semibold text-gray-900 dark:text-white">{{ label }}</h3>
            </div>
            <slot name="description">
              <div v-if="description" class="px-3 py-2">
                  <p>{{ description }}</p>
              </div>
            </slot>
        </div>
    </div>
</template>
<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { generarUuid } from '@/modules/Core/usings/generales'
const props = defineProps<{
  id?: string
  label?: string
  description?: string
}>()
defineSlots<{
  description?: () => string;
}>();

const baseStyleClass ='hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible absolute invisible z-[999] inline-block w-auto text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-400 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800';
const styleClass = {
  default: `${baseStyleClass} max-w-[400px]`,
  withSlot: baseStyleClass,
};
const idComponent = props?.id ? props.id : generarUuid()
const description = ref(props.description)
let element
onMounted(async ()=>{
  if(window.HSTooltip && document.getElementById(idComponent)){
    await nextTick()
    try{
      element = new window.HSTooltip(document.getElementById(idComponent))
    } catch(e) {
      console.error('Error al inicializar el tooltip:', e)
      return
    }
  }
})
onBeforeUnmount(()=>{
  if(element){
    element.destroy()
  }
})
</script>
